module.exports = __webpack_public_path__ + "img/1534618678.9ef3cd4d.jpg";